import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from 'src/app/constants/routes';

/**
 * Abre el detalle de un servicio a partir de su número de orden.
 *
 * El detalle vive bajo `service-manager` y lee el `orderHash` únicamente de los
 * query params, así que basta con la URL: no hay que dejar nada en memoria antes
 * de navegar.
 *
 * Se abre en una pestaña nueva, como ya hace el resto de tablas de la aplicación,
 * para no perder los filtros ni la página en la que estaba la revisión.
 *
 * La URL se compone a mano porque la aplicación usa `HashLocationStrategy`:
 * `serializeUrl` ya devuelve la ruta con `/` inicial, de modo que el separador es
 * `/#` y no `/#/` (con `/#/` saldría `/#//service-manager/...`).
 */
@Injectable({ providedIn: 'root' })
export class ServiceDetailLinkService {
  constructor(private readonly router: Router) {}

  /** `false` si no hay número de orden con el que construir el enlace. */
  canOpen(orderHash: string | null | undefined): boolean {
    return !!orderHash?.trim();
  }

  open(orderHash: string | null | undefined): void {
    const hash = orderHash?.trim();

    if (!hash) {
      return;
    }

    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        [`/${ROUTES.SERVICE_MANAGER}`, ROUTES.DETAIL_SERVICE],
        { queryParams: { orderHash: hash } }
      )
    );

    window.open(`${window.location.origin}/#${url}`, '_blank', 'noopener');
  }
}
